import React from 'react';
import { LoadingSpinner } from '@motili/ui';
import Modal from 'common/components/modal/Modal';
import Config from 'Config';

interface Props {
    handleCloseOnClick: () => void;
    header: React.ReactNode;
    footerMessage: string;
    download: {
        fileName: string;
        url: string;
    };
    message: string;
    state: string;
}
export const DocumentSuccessfullyDownloadAllPhotoModal = (props: Props) => {
    const closeDialog = props.state === 'completed';
    return (
        <Modal
            onCloseClick={props.handleCloseOnClick}
            header={props.header}
            showClose={closeDialog}
            headerContainerStyles={{ marginBottom: '20px', paddingBottom: 0 }}
        >
            {props.state === 'downloading' && <LoadingSpinner size='large' />}
            {props.state === 'completed' && (
                <div style={{ fontSize: '16px' }}>
                    {props.message}
                    {props.download && (
                        <span>
                            &nbsp;Click
                            <a
                                href={props.download.url}
                                download={props.download.fileName}
                                style={{ marginLeft: 5 }}
                            >
                                here
                            </a>
                            &nbsp;to download
                        </span>
                    )}
                    {props.footerMessage && (
                        <div
                            style={{
                                fontSize: 14,
                                fontStyle: 'italic',
                                paddingTop: 5,
                                fontWeight: 400,
                                color: Config.color.mediumGray,
                            }}
                        >
                            {props.footerMessage}
                        </div>
                    )}
                </div>
            )}
        </Modal>
    );
};
